"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultPackChars = void 0;
exports.packModelFonts = packModelFonts;
const fonts_1 = require("./Fonts/fonts");
exports.DefaultPackChars = ' 01234567489';
function packModelFonts(model) {
    const fontChars = new Map();
    function addFontChars(font, chars) {
        if (!chars) {
            return;
        }
        chars = chars.valueOf();
        if (!fontChars.has(font)) {
            fontChars.set(font, new Set(Array.from(exports.DefaultPackChars).map((c) => c.charCodeAt(0))));
        }
        const charSet = fontChars.get(font);
        for (let i = 0; i < chars.length; ++i) {
            if (chars[i] === '\n') {
                continue;
            }
            const char = chars.charCodeAt(i);
            if (!charSet.has(char)) {
                charSet.add(char);
            }
        }
    }
    function parseDrawings(font, drawings) {
        for (const drawing of drawings) {
            switch (drawing.type) {
                case 'text':
                    addFontChars(drawing.font ?? font, drawing.value);
                    break;
                case 'label':
                    addFontChars(font, drawing.value);
                    break;
                case 'pad':
                    addFontChars(font, drawing.name);
                    break;
                case 'pin':
                    addFontChars(font, drawing.name);
                    if (drawing.drawings) {
                        parseDrawings(font, drawing.drawings.map((d) => d.drawing));
                    }
                    break;
                case 'schref':
                    addFontChars(font, drawing.file);
                    addFontChars(font, drawing.name);
                    parseModule(font, 'schematic', drawing.drawModule);
                    break;
                case 'group':
                    parseDrawings(font, drawing.drawings);
                    break;
            }
        }
    }
    function parseModule(font, modelType, module) {
        addFontChars(font, module.name);
        for (const [, prop] of Object.entries(module.drawProperties)) {
            addFontChars(font, prop.value);
        }
        const component = model.components[module.componentRef];
        if (!component) {
            return;
        }
        if (modelType === 'pcb') {
            const footprint = component.footprints.find((f) => f.ref === module.footprintRef);
            if (!footprint) {
                return;
            }
            parseDrawings(font, footprint.drawings.flatMap((d) => d.drawing));
            parseDrawings(font, footprint.pads);
        }
        else if (modelType === 'schematic') {
            const symbol = component.symbols.find((s) => s.ref === module.footprintRef);
            if (!symbol) {
                return;
            }
            parseDrawings(font, symbol.drawings.flatMap((d) => d.drawing));
            parseDrawings(font, symbol.pins);
        }
    }
    for (const design of Object.values(model.designs)) {
        if (!design.font) {
            throw new Error(`Design ${design.designId} has no font`);
        }
        for (const [, drawings] of Object.entries(design.drawings)) {
            parseDrawings(design.font.default, drawings);
        }
        for (const module of design.modules) {
            parseModule(design.font.default, design.modelType, module);
        }
        if ('multiInstanceConfiguration' in design && design.multiInstanceConfiguration) {
            for (const displayModule of design.multiInstanceConfiguration.multiInstanceModules) {
                parseModule(design.font.default, design.modelType, displayModule);
            }
        }
        if (Array.isArray(design.nets)) {
            for (const net of design.nets) {
                addFontChars(design.font.default, net);
            }
        }
        else {
            for (const net of Object.values(design.nets)) {
                addFontChars(design.font.default, net.name);
            }
        }
    }
    for (const [font, chars] of fontChars) {
        const existingFont = model.fonts?.fonts?.[font];
        if (existingFont?.type === 'browser') {
            continue;
        }
        const baseFont = (0, fonts_1.getFont)(font);
        const projectFont = {
            type: 'project',
            ...baseFont,
            name: font,
            glyphs: {},
        };
        const charArray = Array.from(chars).sort();
        let lastChar = Number.NEGATIVE_INFINITY;
        let lastCharGroup;
        const missingChars = [];
        for (let i = 0; i < charArray.length; ++i) {
            const char = charArray[i];
            const glyph = baseFont.glyphs[char - baseFont.startChar];
            if (!glyph) {
                missingChars.push(char);
                continue;
            }
            if (glyph === baseFont.unknownChar) {
                continue;
            }
            if (lastCharGroup && char === lastChar + lastCharGroup.length) {
                lastCharGroup.push(glyph);
            }
            else {
                lastChar = char;
                lastCharGroup = [glyph];
                projectFont.glyphs[lastChar] = lastCharGroup;
            }
        }
        if (missingChars.length > 0) {
            model.warnings.push(`Missing ${missingChars.length} glyphs for font ${font}: ${missingChars.map((c) => String.fromCharCode(c)).join(',')}`);
        }
        model.fonts.fonts[font] = projectFont;
    }
    return model;
}
//# sourceMappingURL=Font.js.map